import React from "react";

import Chevron from "features/common/chevron";

import styles from "./SectionRowChevron.module.scss";

type Props = {
  rotate?: boolean;
  className?: string;
};

export default function SectionRowChevron({ rotate, className }: Props) {
  return <Chevron className={styles.icon} rotate={rotate} />;
}
